import { Smush } from "../../../types/helpers";
import { Product } from "../../../types/types";

export const generatePromotions = (product: Smush<Product>) => {
  const { messaging: messages = [] } = product;

  const promotionalMessages = messages.filter(
    (message) => message.type === "promotional",
  );
  if (promotionalMessages.length === 0) return "";
  return promotionalMessages[0].title.toLowerCase();
};
